import { atom } from "recoil"

const showEditCategorySidebarState = atom({
  key:'ShowEditCategorySidebarState',
  default: false
})

export default showEditCategorySidebarState